import getActivity from '@/api/content/getActivity.endpoint';
import { useEffect, useState, useContext } from 'react';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import getActivityTypeConf from 'src/modules/activities/ActivityTypesConf';
import { FullscreenContext } from '../FullscreenContext/FullscreenContext';

export default function useActivity({ activity, activityConf }) {
  const context = useContext(GlobalContext);
  const fullscreenContext = useContext(FullscreenContext);

  const hasDemoMode = getActivityTypeConf({
    type: activity.type,
    subType: activity.data?.subType,
    miniactivityType: activityConf?.miniactivityType,
  })?.demoMode?.(activity.data);

  const [state, setState] = useState({
    activity,
    activityConf,
    demoMode: hasDemoMode,
    canBeShown: true,
    isTeacher: false,
  });

  const actions = {
    setState: (newState) => {
      setState((previousState) => ({ ...previousState, ...newState }));
    },
    loadActivity: async (id) => {
      const loadedActivity = await getActivity(id);

      actions.setState({
        activity: loadedActivity,
      });
    },
  };

  useEffect(() => {
    if (context.state.loaded) {
      if (activity) {
        if (activity.data) {
          actions.setState({
            activity,
          });
        } else {
          actions.loadActivity(activity.id);
        }
      }
    }
  }, [activity, context.state]);

  useEffect(() => {
    if (state.activity?.data) {
      const canRunWithoutDemo =
        (((context.state.user?.teacher && context.state.isSubscriptionActive) ||
          context.state.user?.student) &&
          context.state.availableLanguages.includes(state.activity.language)) ||
        context.state.user?.admin;

      actions.setState({
        demoMode: hasDemoMode && !canRunWithoutDemo && !state.activity.free,
        canBeShown: state.activity.free || hasDemoMode || canRunWithoutDemo,
        isTeacher: !!context.state.user?.teacher || !!context.state.user?.admin,
        isStudent: !!context.state.user?.student,
      });
    }
  }, [state.activity, context.state]);

  useEffect(() => {
    return () => {
      fullscreenContext.actions.setFullscreen(false);
    };
  }, []);

  return { state, actions };
}
